import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Outlet, Link } from 'react-router-dom';
import Home from './components/Home';
import MovieDetail from './components/MovieDetail';
import TvShowDetails from './components/TvShowDetails';
import Player from './components/Player';
import SearchPage from './components/SearchPage';
import NavBar from './components/Others/NavBar';
import Footer from './components/Others/Footer';
import reportWebVitals from './reportWebVitals';
import './styles/root.css';

const Layout = ({ withFooter = true, withNav = true }) => (
  <>
    {withNav && <NavBar />}
    <main className="app-main">
      <Outlet />
    </main>
    {withFooter && <Footer />}
  </>
);

const NotFound = () => (
  <div className="not-found">
    <h1>404</h1>
    <p>We couldn&apos;t find that page.</p>
    <Link to="/" className="not-found-link">Back to home</Link>
  </div>
);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Pages with their own header (DetailHeader) — bare layout */}
        <Route path="/search" element={<SearchPage />} />
        <Route path="/player/:id" element={<Player />} />
        <Route path="/movie/:id" element={<MovieDetail />} />
        <Route path="/tv/:id" element={<TvShowDetails />} />

        {/* Home and 404 use the global navbar + footer */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
